import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import { getTimezones } from "../../services/uidata";
import { filterVisibleTimeZones, isHTML } from "../../utils/helpers";

//css
import "../checkTimeZone/checktimezone.css";
import { updateBannerStaus } from "../../services/admin";

const generateSrcDoc = (htmlBody) => `
  <html>
    <head>
    <link rel="stylesheet" href="/fonts/style.css" />
     <style>
        body {
          margin: 0;
          font-family: "Oakes-Grotesk-Medium";
          font-size : 14px;
          color: #555;
        }
      </style>
    </head>
    <body>
      ${htmlBody}
      <script>
        function sendHeight() {
          const height = document.body.scrollHeight;
          parent.postMessage({ type: 'setHeight', height }, '*');
        }
        window.onload = sendHeight;
        window.onresize = sendHeight;
      </script>
    </body>
  </html>
`;
export default function AlertPopUp() {
    //states
    // const navigate = useNavigate();
    const dispatch = useDispatch()
    const { banner_text = "", id } = useSelector(
        (state) => state.user.user
    );

    const [newTimezoneData, setnewTimezoneData] = useState([]);
    const [value, setValue] = useState("");
    const [error, setError] = useState(false);


    const closePopup = () => {
        let body = {
            user_id: id
        }
        updateBannerStaus(body).then(() => {
            window.loadModal2("#alertPopup", "hide");
        }).catch(() => {

        })
    }
    const iframeRef = useRef(null);
    const [iframeHeight, setIframeHeight] = useState("100px");
     useEffect(() => {
        const handleMessage = (event) => {
            if (event.data && event.data.type === "setHeight") {
                let height =  event.data.height + 65;
            setIframeHeight(height + "px");
            }
        };

        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
        }, []);

    
    const getInfo = (info) => {

        const rawContentFromDB = info
        let html;
        if (!isHTML(rawContentFromDB)) {
            console.log( info,"ckejdnm1")
            let info =
                rawContentFromDB
                    .split("\n")
                    .map(line => `${line}`)
                    .join("");
            console.log(info, "cejdncjkm");
            html = info
            return info
        }
        else {
           // console.log( info,"ckejdnm2anuj")
            // html = JSON.parse(rawContentFromDB).content
            // return <div dangerouslySetInnerHTML={{ __html: rawContentFromDB }} />
            
              html = JSON.parse(rawContentFromDB).content
              const srcDoc = generateSrcDoc(html);
            return srcDoc 
        }

// "{\"content\":\"<p style=\\\"margin-left:0px;\\\">Try a Community Support Group:</p>\\n<ol>\\n<li><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Male Mediums - Ed S. Mediums Who Speak French - Cindy L.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unsupported: Doubt/Fear from Family/Friends = Lisa A.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unity: Group Meditation - Amber K. Healing Session for Mediums - Catherine B.</span></li>\\n</ol>\\n\"}"

    }
    return (
        <div
            className="modal fade mt-5 "
            id="alertPopup"
            data-backdrop="static"
            role="dialog"
        >
            <div className="modal-dialog modal-dialog-alert-box modal-xl">
                <div className="modal-content">
                    <div className="modal-body mb-4">
                        <div className="schedule-popup">
                            <div className="d-flex align-items-center justify-content-between">

                                <span className="d-flex align-items-center margin-unset">
                                    <img className='w-50-px' src="./images/heart.png" />
                                    <span className="font-size-28 ml-1 ">Info</span>

                                </span>
                                <span className="pointer align-self-baseline" onClick={closePopup}>

                                    X
                                </span>
                            </div>


                            {/* <h3 className="text-center ">
                                <img className='w-70-px' src="./images/error-mark.png" />
                            </h3> */}
                            <div className="mb-2 mt-2">
                                <div className="cuntrey-website p-2 line-height-30px">
                                    {}
                                    <iframe 
                                        ref={iframeRef}
                                        srcDoc={getInfo(banner_text)}
                                        style={{ width: "100%",height: iframeHeight, border: "unset" }}
                                        title="Editor Preview"
                                        />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
